import React, { useState, useEffect } from "react";
import { Popover, Input, List, Tag, Spin, Empty, Button } from "antd";
import { GiftOutlined } from "@ant-design/icons";
import moment from "moment";
import request from "utils/api";

const VoucherPicker = ({ onSelect, disabled }) => {
  const [visible, setVisible] = useState(false);
  const [vouchers, setVouchers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");

  const fetchVouchers = async (keyword = "") => {
    setLoading(true);
    try {
      const res = await request(
        "api/fonehouse/voucher",
        { page: 1, limit: 20, keyword: keyword || undefined, status: "ACTIVE" },
        { method: "GET" }
      );
      setVouchers(res?.data?.docs || []);
    } catch {
      setVouchers([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (visible) {
      fetchVouchers();
    }
  }, [visible]);

  const handleSearch = (val) => {
    setSearch(val);
    fetchVouchers(val);
  };

  const handleSelect = (voucher) => {
    setVisible(false);
    setSearch("");
    onSelect(voucher);
  };

  const renderDiscount = (v) => {
    if (v.discountType === "PERCENTAGE") {
      return `Giảm ${v.discountValue}%`;
    }
    return `Giảm ¥${(v.discountValue || 0).toLocaleString()}`;
  };

  const content = (
    <div style={{ width: 320, maxHeight: 400, overflow: "auto" }}>
      <Input.Search
        placeholder="Tìm mã voucher..."
        value={search}
        onChange={(e) => handleSearch(e.target.value)}
        size="small"
        style={{ marginBottom: 8 }}
        allowClear
      />
      {loading ? (
        <div style={{ textAlign: "center", padding: 20 }}>
          <Spin size="small" />
        </div>
      ) : vouchers.length === 0 ? (
        <Empty
          image={Empty.PRESENTED_IMAGE_SIMPLE}
          description="Không có voucher"
        />
      ) : (
        <List
          size="small"
          dataSource={vouchers}
          renderItem={(v) => {
            const isExpired = new Date(v.endDate) < new Date();
            const isUsed = v.usedCount > 0;
            return (
              <List.Item
                onClick={() => !isExpired && handleSelect(v)}
                style={{
                  cursor: isExpired ? "not-allowed" : "pointer",
                  opacity: isExpired ? 0.5 : 1,
                  padding: "8px 4px",
                  borderBottom: "1px solid #f0f0f0",
                }}
              >
                <div style={{ width: "100%" }}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <Tag color="red" style={{ fontWeight: "bold" }}>
                      #{v.code}
                    </Tag>
                    <span
                      style={{
                        color: "#1890ff",
                        fontWeight: 600,
                        fontSize: 13,
                      }}
                    >
                      {renderDiscount(v)}
                    </span>
                  </div>
                  <div
                    style={{
                      fontSize: 12,
                      color: "#666",
                      marginTop: 2,
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", maxWidth: 180 }}>
                      {v.title}
                    </span>
                    <span>
                      {isUsed ? (
                        <Tag color="green" style={{ fontSize: 10, margin: 0 }}>Đã dùng</Tag>
                      ) : (
                        <span style={{ fontSize: 11, color: "#999" }}>
                          HSD: {moment(v.endDate).format("DD/MM")}
                        </span>
                      )}
                    </span>
                  </div>
                </div>
              </List.Item>
            );
          }}
        />
      )}
    </div>
  );

  return (
    <Popover
      content={content}
      title="Chọn voucher để gửi"
      trigger="click"
      visible={visible}
      onVisibleChange={setVisible}
      placement="topLeft"
    >
      <Button
        type="text"
        icon={<GiftOutlined style={{ fontSize: 20, color: "#eb2f96" }} />}
        disabled={disabled}
        title="Gửi voucher"
      />
    </Popover>
  );
};

export default VoucherPicker;
